import {Injector, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {SidebarSearchComponent} from "./search.component";
import {createCustomElement} from "@angular/elements";


@NgModule({
    declarations: [
        SidebarSearchComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        RouterModule
    ],
    exports: [SidebarSearchComponent]
})
export class SidebarSearchModule_Catalogue {
    constructor(private injector: Injector) {
        const comp = createCustomElement(SidebarSearchComponent, {injector});
        !customElements.get('ngx-catalogue-sidebar-search') && customElements.define('ngx-catalogue-sidebar-search', comp);
    }
}
